export const WAREHOUSE_ROUTE_NAMES = {
  ASN_IMPORT: 'warehouse-asn-import',
  OUTBOUND_QUEUE: 'warehouse-outbound-queue',
  REPLENISHMENT_QUEUE: 'warehouse-replenishment-queue',
  SHIPMENTS: 'shipments',
  WAREHOUSE: 'warehouse',
  WAREHOUSE_FULFILLMENT_QUEUE: 'warehouse-fulfillment-queue',
  WAREHOUSE_WILDCARD: 'warehouse-wildcard',
};
